// @flow

import * as React from 'react';

import clsx from 'clsx';

import { Base, Button, Svg, type BaseProps } from '@gandi/ui';

import { NavigationContext } from '../../context/Navigation';

import Logo from './Logo';

import styles from './Controls.scss';

export type Props = {
  className?: string,
  ...
} & BaseProps;

function Controls({ className, ...extraProps }: Props): React.Node {
  const { toggleOpen } = React.useContext(NavigationContext);

  return React.useMemo(() => {
    const handleOpen = (evt: SyntheticEvent<HTMLAnchorElement>) => {
      evt.preventDefault();

      toggleOpen();
    };

    const rootClasses = clsx(styles.root, className);

    return (
      // $FlowFixMe[cannot-spread-inexact]
      <Base
        flex
        flexJustifyBetween
        flexAlignItemsCenter
        className={rootClasses}
        {...extraProps}
      >
        <div>
          <Svg name="gandiIcon" theme="white" className={styles.gandi} />

          <Logo className={styles.logo} />
        </div>
        <Button
          kind="link"
          type="button"
          className={styles.close}
          onClick={handleOpen}
        >
          <Svg name="cross" theme="white" />
        </Button>
      </Base>
    );
  }, [className, extraProps, toggleOpen]);
}

export { Controls };
